<template>
    <div class="contenido">
        <Loading :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />
        <Titulo titulo="FINALIZAR PAGO" />

        <b-container class="aviso">
            <b-row class="mt-5 text-center">
                <b-col>
                    <h3>¡Gracias, has realizado tu pago!</h3>
                </b-col>
            </b-row>
            <b-row class="mb-5 text-center">
                <b-col>
                    <h5>Revisa tu correo electrónico {{ emailUsuario }} para ver la confirmación del mismo.</h5>
                </b-col>
            </b-row>
        </b-container>

        <b-container class="regresar">
            <!-- el boton de regresar -->
            <b-row class="mt-5 text-right">
                <b-col>
                    <b-button
                        variant="primary"
                        @click="regresar"
                    >
                        <b-icon-chevron-left></b-icon-chevron-left> Regresar
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Titulo from "@/components/Titulo.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    name: "FinalizarPago",
    components: {
        Titulo,
        Loading,
    },
    data() {
        return {
            // el usuario logueado
            emailUsuario: 0,
            // el spinner de carga
            isLoading: true,
            fullPage: true,
        };
    },
    created() {
        this.emailUsuario = localStorage.getItem("emailUsuario");
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        regresar() {
            this.$router.push("/consultasaldo");
        }
    }
}
</script>

<style scoped>
    .contenido {
        min-height: 500px;
    }

    .aviso {
        margin-top: 100px;
        min-height: 250px;
    }
</style>